const NOTION_EMBED_URL =
  "https://berry-gallimimus-4a8.notion.site/ebd/3a2bbe366364803493e1eaea1d80afd7?v=3a2bbe36636480cab055000c65e6adee";

const Tasks = () => {
  return (
    <div className="h-screen w-screen overflow-hidden bg-white">
      <iframe
        src={NOTION_EMBED_URL}
        title="Tasks"
        className="h-full w-full border-0"
        allowFullScreen
      />
    </div>
  );
};

export default Tasks;
